import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	releases: {
		id: 'project-versions.releases',
		defaultMessage: 'Releases',
		description: 'Page title for the Releases page',
	},
	createVersionButton: {
		id: 'project-versions.create-version-button',
		defaultMessage: 'Create version',
		description: 'The button that allows users to create a new version',
	},
	successFlagDescription: {
		id: 'project-versions.success-flag-description',
		defaultMessage: '{name} created.',
		description:
			'The description of the flag that is displayed when creating a version is successful.',
	},
});
